module.exports = __webpack_public_path__ + "insertar-icono-de-imagen.png";